import { apiClient } from "./apiClient";

export const createClient = async (datosFinales) => {
  try {
    const response = await apiClient.post(
      `/ventas/api/v1/ventas`,
      datosFinales,
    );
    return { ...response.data, httpStatus: response.status };
  } catch (error) {
    const httpStatus = error.response?.status ?? null;
    if (error.response?.data?.status) {
      const { message, statusCode } = error.response.data.status;
      return { success: false, message, statusCode, httpStatus, sinRespuesta: false };
    }
    return {
      success: false,
      message: "Ocurrió un error inesperado",
      statusCode: null,
      httpStatus,
      // Sin respuesta de Iptel (red, timeout o error del servidor sin detalle):
      // el alta PUEDE haberse creado igual.
      sinRespuesta: !error.response || httpStatus >= 500,
    };
  }
};
